<template>
  <v-card class="neu-card my-3">
    <v-card-text>
      <v-row class="align-center">
        <v-col cols="auto" sm="2" class="pr-0 pr-sm-auto">
          <v-img
            :width="lgAndUp ? '7.5vh' : '7vh'"
            :height="lgAndUp ? '7.5vh' : '7vh'"
            class="mx-auto rounded-xl neu-shadow"
            :src="product.pictures[0]"
            cover
          >
            <template v-slot:placeholder>
              <div class="d-flex align-center justify-center fill-height">
                <v-progress-circular
                  color="accent"
                  indeterminate
                  width="1"
                  size="20"
                />
              </div>
            </template>
          </v-img>
        </v-col>
        <v-col>
          <h2 class="monkey-title d-flex">{{ product.name }}</h2>
          <h3 class="text-caption">
            {{ showableDesc }}
          </h3>
        </v-col>
        <v-col cols="12" sm="auto">
          <v-row class="align-center">
            <v-col sm="auto" class="pr-0">
              <h3 class="monkey-title">
                {{ Number(product.fullValue).toLocaleString(undefined, {minimumFractionDigits: 2}) }}€
              </h3>
              <span class="text-caption text-medium-emphasis">({{ Number(product.value).toLocaleString(undefined, {minimumFractionDigits: 2}) }} / unité)</span>
            </v-col>
            <v-col cols="auto">
              <v-btn
                variant="icon"
                color="primary"
                icon="fas fa-minus"
                size="x-small"
                @click="$emit('setQuantity', product.id, product.quantity - 1)"
              />
              <span class="font-weight-bold">{{ product.quantity }}</span>
              <v-btn
                variant="icon"
                color="primary"
                icon="fas fa-plus"
                size="x-small"
                @click="$emit('setQuantity', product.id, product.quantity + 1)"
              />

              <v-btn
                variant="icon"
                color="error"
                icon="fas fa-xmark"
                size="small"
                @click="$emit('removeProduct', product.id)"
              />
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-card-text>
  </v-card>
</template>

<script setup>
import { useDisplay } from "vuetify";

const { lgAndUp } = useDisplay();
</script>

<script>
export default {
  name: "InlineProductComponent",
  props: {
    product: {
      type: Object,
      required: true,
    },
    actions: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  computed: {
    showableDesc: function() {
      const productDesc = this.product.shortDesc.replace(/<\/?[a-z][a-z0-9]*[^<>]*>|<!--.*?-->/img, "");
      const maxLength = 60;

      var trimmedString = productDesc.substr(0, maxLength);

      return trimmedString.substr(0, Math.min(trimmedString.length, trimmedString.lastIndexOf(" "))) + "...";
    },
  },
};
</script>
